import React from 'react'
import ReactDatePicker from 'react-datepicker'
import * as fmt from '../util/fmt_utils'

class DatePicker extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.show = this.show.bind(this)
        this.hide = this.hide.bind(this)
    }

    handleChange(date) {
        this.props.onChange(date)
    }

    show() {
        this.reactPicker.setOpen(true)
    }

    hide() {
        this.reactPicker.setOpen(false)
    }

    render() {
        const { isMobile, selectedDate, className, calendarClassName } = this.props
        const momentDate  = fmt.getMoment(selectedDate)
        return (
            <ReactDatePicker
                selected={momentDate}
                onChange={this.handleChange}
                className={className}
                calendarClassName={calendarClassName}
                popoverTargetAttachment='top center'
                popoverTargetOffset="22px -140px"
                ref={ref => this.reactPicker = ref}
                withPortal={isMobile}
            >
                <div onClick={() => this.props.handleEnterDate()} className='date-picker-child'>
                    <p>EDIT</p>
                </div>
            </ReactDatePicker>
        )
    }
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/components/date_picker.jsx